export const COOKIES_TAGS = {
  USER_EMAIL: "electy-server@user-email",
  SIMULACAO_DATA: "electy-server@simulacao-data",
  LEAD_ID: "electy-server@lead-id",
}